import {
  Button,
  Box,
  Modal,
  Table
} from '@platform/ui-library';
import ReactDOM from 'react-dom';
import {
  Design,
  DesignMetaDataBreakingChange
} from '../../types';
import { formatDateTime } from '../../utilities';

export interface BreakingChangesDialogProps {
  breakingChanges: DesignMetaDataBreakingChange[];
}

interface BreakingChangesInterface <TProps> extends React.FC<TProps> {
  popupIfBreakingChangesExist({
    currentVersion,
    savedVersion
  }: {
    currentVersion: Design;
    savedVersion: Design;
  }): boolean;
}

const classes = [
  'breaking-changes-dialog',
  'container-fluid',
  'element-dialog'
];
const dialogId = 'breaking-changes-dialog';
/** Dialog used to validate various parts of the design. */
export const BreakingChangesDialog: BreakingChangesInterface<BreakingChangesDialogProps> = ({ breakingChanges }: BreakingChangesDialogProps) => {

  const dataTable = breakingChanges.map(({ message, timestamp }) => ({ 'Timestamp': formatDateTime(timestamp), 'Message': message }));

  const handleClose = () => {
    ReactDOM.unmountComponentAtNode(document.getElementById(dialogId) as Element);
  };

  return (
    <Modal id={dialogId+'-id'} style={{ zIndex: 1500 }} isOpen={true} handleClose={handleClose} >
      <Box theme='bigPadding' className={classes.join(' ')}>
        <div className="row">
          <div className="col-md-12">
            <h3>Breaking Changes</h3>
          </div>
        </div>
        <div className="row" style={{ marginBottom: '10px' }}>
          <div className="col-md-12 flex-center-column">
            <p>Breaking changes have happened on the latest version of this application.</p>
            <p>Saving from this version is disabled to prevent breaking the application. Please download the latest version prior to making changes you wish to save.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12" >
            <Table data={dataTable} />
          </div>
        </div>
        <div className="row">
          <div className={'col-md-12'}>
            <hr
              style={{
                marginTop: '15px',
                marginBottom: '10px'
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 flex-end">
            <Button
              theme='outline'
              onClick={handleClose}
            > {window.l.popup.close}</Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

BreakingChangesDialog.popupIfBreakingChangesExist = ({
  currentVersion,
  savedVersion
}: {
  currentVersion: Design;
  savedVersion: Design;
}) => {
  const currentBreakingChange = currentVersion.metaData?.breakingChanges?.[0];
  const missingBreakingChanges = savedVersion.metaData?.breakingChanges?.filter((breakingChange) => {
    return breakingChange.timestamp > (currentBreakingChange?.timestamp ?? 0);
  });

  if (!missingBreakingChanges?.length) {
    return false;
  }

  // create a div to render the modal into if it doesn't already exist
  if (!document.getElementById(dialogId)) {
    document.body.appendChild(document.createElement('div')).setAttribute('id', dialogId);
  }

  ReactDOM.render( <BreakingChangesDialog breakingChanges={missingBreakingChanges} />, document.getElementById(dialogId));

  return true;
};
